import React from 'react';
import { Modal } from 'react-bootstrap';
import LayoutDetails from './LayoutDetails';

export default function ModalWrapper({
  children,
  show,
  title,
  handleClose,
  handleSave,
  handleSchedule,
  isSaveDisabled = false,
  layoutDetails,
}) {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        &nbsp;
        <button
          onClick={handleClose}
          type="button"
          className="btn modalButtons btn-primary"
        >
          Close
        </button>
        <button
          onClick={handleSave}
          type="button"
          className="btn modalButtons btn-success"
          disabled={isSaveDisabled}
          style={{
            opacity: isSaveDisabled ? 0.65 : 1,
            cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          Save
        </button>
        <button
          onClick={handleSchedule}
          type="button"
          className="btn modalButtons btn-success"
        >
          Schedule
        </button>
      </Modal.Footer>
      {layoutDetails &&
        Array.isArray(layoutDetails) &&
        layoutDetails.length > 0 && (
          <LayoutDetails layoutDetails={layoutDetails} />
        )}
    </Modal>
  );
}
